import * as React from 'react'

export type IconProps = React.SVGProps<SVGSVGElement> & {
  size?: number | string
  color?: string
  strokeWidth?: number
}

/**
 * ReferenceIcon
 * A book with a ribbon bookmark — suitable for "Docs", "Reference", or "Manual".
 */
const ReferenceIcon: React.FC<IconProps> = ({
  size = 24,
  color = 'currentColor',
  strokeWidth = 2,
  className,
  ...props
}) => {
  const s = typeof size === 'number' ? `${size}` : size
  return (
    <svg
      width={s}
      height={s}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={className}
      {...props}
    >
      {/* Book body outline (right cover and page block) */}
      <path d="M6 4h9a2 2 0 0 1 2 2v12" />
      {/* Book spine */}
      <path d="M6 4v16" />
      {/* Bottom curve indicating thickness when open */}
      <path d="M6 20h9a2 2 0 0 0 2-2" />
      {/* Ribbon bookmark */}
      <path d="M14 4v6l-2-1-2 1V4" />
      {/* Indicative lines for reference text */}
      <path d="M8.5 11.5h6" />
      <path d="M8.5 15h5" />
    </svg>
  )
}

export default ReferenceIcon
